module.exports = __webpack_public_path__ + "img/rsz_1.6debf7c8.png";